<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>

    <section class="mainTopBanner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="topBannerWrapper">
                        <div class="top-banner-left">
                            <h1>ブラウザプラグイン</h1>
                            <h2>ブラウザ プラグイン</h2>
                            <p>Trinkaのブラウザ拡張機能をインストールすれば、サイト上で書き込むメッセージや投稿、ブログ記事の執筆などもリアルタイムで校正。オンラインでの質の高い英文ライティングが可能になります。
                            </p>
                            <div id="safariBrowser">
                                    <button title="Safariでまもなく登場">
                                        <img src="assets/images/safari_logo.png" alt="safari - 文法 チェック"> 近日公開</button>
                                    <div class="downloadForSafari">
                                        <h2>ダウンロード：</h2>
                                        <ul>
                                            <li>
                                                <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"
                                                    title="Download for Chrome">
                                                    <img src="assets/images/NewChromeFicon.svg" alt="chrome - 文法 チェック">
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" title="Download for Firefox">
                                                    <img src="assets/images/NewFirefoxFicon.svg" alt="文法 チェック Firefox">
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" title="Download for Edge">
                                                    <img src="assets/images/EdgeWhite_BGAndOutline.svg" alt="edge - 文法 チェック">
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div id="BrowserGoogleChromeSection">
                                    <div class="browserPluginButton">
                                        <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"
                                            class="buttonGoogleChrome" id="BrowserChromeButton">
                                            <b>
                                                <img src="assets/images/NewChromeIcon.svg" alt="Chrome - 文法 チェック">
                                            </b>
                                            <i>
                                                <u style="text-decoration: none;" class="OpenSansFonts">Chrome</u>にインストール</i>
                                        </a>
                                        <!-- <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank" 
                                    class="buttonFireFox" id="BrowserFireFoxButton">
                                        <b>
                                            <img src="assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Firefox">
                                            </b>
                                            <i><u style="text-decoration: none;" class="OpenSansFonts">Firefox</u>にインストール</i>
                                    </a> -->
                                    </div>
                                    <br />
                                    <div class="commingSoonSeciton">
                                        <p class="FirefoxAvalibale">
                                            <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank">
                                                <img style="width: 32px;" src="assets/images/NewFirefoxIcon.svg" alt="文法 チェック Firefox">
                                                <u style="text-decoration: none;" class="OpenSansFonts">Firefox</u> にインストール
                                            </a>
                                        </p>
                                        <p class="SafariComingSoon EdgeBrowserPlugin">
                                            <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank">
                                                <img style="width: 30px;" src="assets/images/EdgeWhite_BGAndOutline.svg" alt="文法 チェック Chrome">
                                                <u style="text-decoration: none;" class="OpenSansFonts">Edge</u> にインストール
                                            </a>
                                        </p>
                                    </div>
                                </div>
                                <div id="BrowserFirefoxSection">
                                    <div class="browserPluginButton">
                                        <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank" class="buttonFireFox" id="BrowserFireFoxButton">
                                            <img style="width: 32px;" src="assets/images/NewFirefoxIcon.svg" alt="文法 チェック Firefox">
                                            <u style="text-decoration: none;" class="OpenSansFonts">Firefox</u> にインストール
                                        </a>
                                    </div>
                                    <br />
                                    <div class="commingSoonSeciton">
                                        <p class="FirefoxAvalibale">
                                            <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank">
                                                <img style="width: 32px;" src="assets/images/NewChromeIcon.svg" alt="文法 チェック Firefox">
                                                <u style="text-decoration: none;" class="OpenSansFonts">Chrome</u>にインストール
                                            </a>
                                        </p>
                                        <p class="SafariComingSoon EdgeBrowserPlugin">
                                            <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank">
                                                <img style="width: 30px;" src="assets/images/EdgeWhite_BGAndOutline.svg" alt="文法 チェック Chrome">
                                                <u style="text-decoration: none;" class="OpenSansFonts">Edge</u> にインストール
                                            </a>
                                        </p>
                                    </div>
                                </div>
                                <div id="BrowserEdgeBrowserSection">
                                    <div class="browserPluginButton">
        
                                        <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank"
                                            class="buttonEdgeBrowser buttonGoogleChrome" id="BrowserEdgeButton">
                                            <b>
                                                <img src="assets/images/EdgeWhite_BGAndOutline.svg" alt="文法 チェック Firefox">
                                            </b>
                                            <u style="text-decoration: none;" class="OpenSansFonts">Edge</u> にインストール
                                        </a>
                                    </div>
                                    <br />
                                    <div class="commingSoonSeciton">
                                        <p class="FirefoxAvalibale">
                                            <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank">
                                                <img style="width: 32px;" src="assets/images/NewChromeIcon.svg" alt="文法 チェック Firefox">
                                                <u style="text-decoration: none;" class="OpenSansFonts">Chrome</u>にインストール
                                            </a>
                                        </p>
                                        <p class="SafariComingSoon EdgeBrowserPlugin">
                                            <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank">
                                                <img style="width: 30px;" src="assets/images/NewFirefoxIcon.svg" alt="文法 チェック Chrome">
                                                <u style="text-decoration: none;" class="OpenSansFonts">Firefox</u> にインストール
                                            </a>
                                        </p>
                                    </div>
                                </div>
                        </div>
                        <div class="top-banner-right">
                            <img src="assets/images/BrowserPlugin_banner.png" class="img-fluid md50" alt="プラグイン">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- 
    <div class="how_it_work_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="how_it_work_content">
                        <h2><span></span>使い方は とっても<br />シンプル</h2>
                        <ul>
                            <li>
                                <div class="login_circle_section">
                                    <img src="assets/images/TypeOrImportFile_icon.png" alt="">
                                </div>
                                <h3>ブラウザ プラグインを<br />インストール</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="assets/images/RegisterAndLogin.png" alt="">
                                </div>
                                <h3>ログイン／登録</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="assets/images/improveYourWriting_icon.png" alt="">
                                </div>
                                <h3>執筆スタート</h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="brandlogo_heading">
                        <h2>Trinkaのプラグインが使えるソフトウェアやWebサービス例：</h2>
                    </div>
                    <div class="cover_wrapper">
                        <div id="client-logos" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/google-docs.png" alt="google docs - 文法 チェック">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/authorea.png" alt="authorea - 文法 チェック">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/researchgate.png" alt="research gate - 文法 チェック">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/medium.png" alt="medium - 文法 チェック">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/writing-cooprative.png" alt="writing - 文法 チェック">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/evernote.png" alt="evernote - 文法 チェック">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/notion.png" alt="notion - 文法 チェック">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/linked-in.png" alt="linked-in - 文法 チェック">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/twitter.png" alt="twitter - 文法 チェック">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/gmail.png" alt="gmail - 文法 チェック">
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="viewfullList">
                        <a routerLink="/brand-list">View Full List</a>
                        ... and many more
                    </div> -->
                </div>
            </div>
        </div>
    </div>
    
    <div class="cloud_key_features section-pd list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-lg-12">
                    <div class="trinka-title mb-0 text-center">
                        <h2>Trinkaブラウザ プラグインの特徴</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>Trinkaブラウザ プラグインは、お使いのブラウザでいつでもどこでも質の高い英文ライティングを実現するための拡張機能です。リアルタイムで校正・修正案を提示し、変更箇所も自動的にチェック。自分らしいメッセージを正しい英語で発信できます。</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-none">
                        <img src="assets/images/realTimeEditing_icon.svg" alt="リアルタイムの英文校正 - 英文校正">
                        <h3>リアルタイムの英文校正</h3>
                        <p>書いたその場でTrinkaが修正案を提示。校正者のフィードバックを待つわずらわしさもありません。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <img src="assets/images/AddtoDictionary.svg" alt="辞書への追加 - 英文校正">
                        <h3>辞書への追加</h3>
                        <p>マイ・ディクショナリーに用語を追加すれば、Trinkaがそれをスペルミスと判断することはなくなります。マイ・ディクショナリーはProfile欄から確認・編集もできます。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <img src="assets/images/DataSecurityIcon.svg" alt="安心のデータセキュリティ - 英文校正">
                        <h3>安心のデータセキュリティ</h3>
                        <p>入力した文章はリアルタイムで分析され、Trinkaのサーバーに保存されることはありません。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="writeToolboxs_section section-pd pb-0 pt-0">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-lg-12 col-md-12">
                    <div class="trinka-title mb-0 text-center">
                        <h2>Trinkaのプラグインで、いつでもどこでも良質なライティングを</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
        </div>

        <section class="section-pd list-wrapper-style-2 ">
            <div class="trinka_container">
                <div class="row align-items-center flex-row-reverse">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2">
                            <h3>Googleドキュメントで自動英文校正</h3>
                            <p>Googleドキュメントで簡単に文法ミスを修正し、質の高い英作文を。</p>
                            <p>Trinkaのブラウザ拡張機能を加えれば、Googleドキュメント上で文法ミスやスペルミスのリアルタイムでの修正、英文の改善が可能になります。</p>
                            <!-- <a href="#">
                                Read More
                                <img src="assets/images/ReadMoreArrow.png" alt="">
                            </a> -->
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image features-img">
                            <img src="assets/images/google-doc-ss.jpg" alt="英文校正 google doc" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-pd list-wrapper-style-2 pt-0">
            <div class="trinka_container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2 pr-80">
                            <h3>Authoreaでより良い英文を執筆</h3>
                            <p>Authoreaで英語論文を執筆するなら、文法修正ツールTrinkaで文章のクオリティをアップ。</p>
                            <p>Trinkaのブラウザプラグインでは、文法ミスのリアルタイムの修正が可能に。英文改善にお役立ていただけます。</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image features-img">
                            <img src="assets/images/authorea-ss.jpg" alt="英文校正 authorea" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-pd list-wrapper-style-2 pt-0">
            <div class="trinka_container">
                <div class="row align-items-center flex-row-reverse">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2">
                            <h3>Evernoteでの英文ライティングを自動修正</h3>
                            <p>Evernoteでの英文ライティングを改善。AI搭載の<a [routerLink]="['/grammar-checker']">英文校正</a>ツールTrinkaは、リアルタイムで文法ミスを修正し言葉の質を高めます。</p>
                            <p>Trinkaのブラウザ拡張機能はEvernoteに完全対応。使いやすいプラグインで、文章を簡単に確認・校正できます。</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image features-img">
                            <img src="assets/images/evernote-ss.jpg" alt="evernote - 英文チ ェッカー" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-pd list-wrapper-style-2 pt-0">
            <div class="trinka_container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2 pr-80">
                            <h3>WebサービスMedium上でのライティング改善</h3>
                            <p>Mediumでのブログ執筆なら、Trinkaの無料ブラウザプラグインの編集機能をぜひご活用ください。</p>
                            <p>Trinkaは、英文の文法、トーン、句読点、文章構造などを修正し、読者を惹きつける英文作成にお役立ていただけます。</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image features-img">
                            <img src="assets/images/medium-ss.jpg" alt="medium - ai英文校正" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>

    <div class="browser_plugin_cta">
        <div class="trinka_container">
            <div class="row">
                <div class="col-lg-12" id="BrowserGoogleChromeSection_cta">
                    <div class="trinka_cloud_banner_text">

                        <div class="browserPluginButton">
                            <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"
                                class="buttonGoogleChrome" id="BrowserChromeButton">
                                <b>
                                    <img src="assets/images/NewChromeIcon.svg" alt="文法 チェック Chrome">
                                </b>
                                <i>Chromeにインストール</i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12" id="BrowserFirefoxSection_cta">
                    <div class="trinka_cloud_banner_text">
                        <div class="browserPluginButton">
                            <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank" class="buttonFireFox" id="BrowserFireFoxButton_cta">
                                <b>
                                    <img src="assets/images/NewFirefoxIcon.svg" alt="文法 チェック Firefox">
                                </b>
                                <i>Firefoxにインストール</i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12" id="BrowserEdgeBrowserSection_cta">
                    <div class="trinka_cloud_banner_text">
                        <div class="browserPluginButton">

                            <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank"
                                class="buttonEdgeBrowser buttonGoogleChrome" id="BrowserEdgeButton">
                                <b>
                                    <img src="assets/images/EdgeWhite_BGAndOutline.svg" alt="文法 チェック Firefox">
                                </b>
                                <i>Edgeにインストール</i>
                            </a>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="otherApps section-pd-sm">
        <div class="trinka_container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">もっとあります
                            Trinkaの
                            使い方</h3>
                    </div>
                    <ul>
                        <li>
                            <a [routerLink]="['/trinkacloud']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Other_apps_TrinkaCloud.svg" alt="cloud - 文法 チェック">
                                    <h3>Cloud</h3>
                                </div>
                            </a>
                        </li>
                        <!-- <li>
                            <a [routerLink]="['/wordplugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Others_App_MSWord.svg" alt="ms word">
                                    <h3><span class="OpenSansFonts" style="font-weight: bold;">MS Word</span>
                                        <br /> プラグイン</h3>
                                </div>
                        </a>
                        </li> -->
                        <li>
                            <a [routerLink]="['/browser-plugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/other_Apps_browser.svg" alt="browser - 文法 チェック">
                                    <h3>ブラウザ
                                        <br />プラグイン</h3>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/enterprise']">
                                <div class="app_name_content" style="padding: 0px;">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Other_Apps_enterprise.svg" alt="enterprise - 文法 チェック">
                                    <h3 style="margin: 0 0 -2px 0;">Enterprise</h3>
                                    <span style="font-size: 12px; color: #000; position: relative;">(API, JS, & On-Premise)</span>
                                </div>
                            </a>
                        </li>
                        
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>